import { ConsentManagerScripts } from '@eventbrite/webapp-data';

/**
 * The consent banner/GTM scripts for a folded surface, mounted from its
 * `getLayout` (the host's equivalent of the standalone `_app`). Must not go in
 * `_document`: those tags are `afterInteractive`, a strategy `_document`
 * silently drops. The `beforeInteractive` Transcend airgap stays in
 * `_document` (see the `surfaceDocumentSignal` branch there); without it the
 * banner waits forever on `airgap.ready`.
 *
 * Skip this where the surface already pulls it in transitively
 * (conversions-manager, via `EventCreatorNav`) or the scripts duplicate.
 */
export function SurfaceConsentScripts() {
  return <ConsentManagerScripts />;
}
